import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import * as moment from 'moment';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-createfieldvisitcode',
  templateUrl: './createfieldvisitcode.component.html',
  styleUrls: ['./createfieldvisitcode.component.css']
})
export class CreatefieldvisitcodeComponent implements OnInit {

  @ViewChild('agGrid',{static:false}) agGrid: AgGridAngular;
  FieldVisitCodecolumnDefs = [
    {headerName: 'ID', field: '_id', width: 250, checkboxSelection: true,headerCheckboxSelection: true,sortable: true, filter: true},
    // {headerName: 'Bank ID', field: 'bank_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Field Visit CODE', field: 'fvcode', resizable: true, sortable: true, filter: true},
    {headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
      return moment(data.value).format('LLLL');
    }},
    {headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
      return moment(data.value).format('LLLL');
    }},
    {headerName: 'Status', field: 'status', sortable: true, filter: true},
    {headerName: 'Options', width: 120,cellRenderer: function(params) {
      return "";
    }},
  ];

  fieldvisitForm: UntypedFormGroup;
  fieldvisitCodeList: any[];
  editmode: boolean;
  addmode: boolean;
  banknameList: any[];

  constructor(private formBuilder:UntypedFormBuilder, private _api:ApiService, @Inject(SESSION_STORAGE) private storage: StorageService) { 
    this.fieldvisitForm = this.formBuilder.group({
      _id:[''],
      // bank_id:['',Validators.required],
      fvcode:['',Validators.required],
      status:['',Validators.required]
    });
  }

  ngOnInit(): void {
    this.addmode = true;
    this.editmode = false;

    this._api.getlist_fieldvisit_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.fieldvisitCodeList = data['Data'];
      } else {
        this.fieldvisitCodeList = [];
      }
    });

    console.log("Client Id Detail",this.getFromLocal("Client_ID"))
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.fetch_bank_list_by_client_id(a).subscribe(
      (response: any) => {
        console.log(response);
        this.banknameList = [];
       var hash = response.Data.reduce((p,c) => (p[c.bank_name] ? p[c.bank_name].push(c) : p[c.bank_name] = [c],p) ,{});
       var  newData = Object.keys(hash).map(k => ({color: k, car: hash[k]}));
       console.log(newData);
        for(let a = 0 ; a < newData.length; a ++){
          let x =  { 'y': newData[a].color}
          this.banknameList.push(x);
        }
        // this.rows = response.Data.reverse();
        // console.log(this.rows);
      });
  }

  
  getFromLocal(key): any {
    return this.storage.get(key);
  }

  addbcode(){
    if (this.fieldvisitForm.valid) {
      // for (let i = 0; i < this.fieldvisitForm.value.bank_id.length; i++) {
        const data = {
          bank_id:'',
          fvcode:this.fieldvisitForm.value.fvcode,
          status:this.fieldvisitForm.value.status
        }
        this._api.create_fieldvisit_code(data).subscribe(data=>{
          if (data['Code'] == 200) {
            this.onreloadPage();
          } else {
            alert(data['Message']);
          }
        });
      // }
      
    } else {
      alert("Please Fill all fields");
    }
  }

  editbcode(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data );
    if (selectedData.length == 1) {
      this.addmode = false;
      this.editmode = true;
      this.fieldvisitForm.patchValue({
        _id:selectedData[0]._id,
        bank_id:'',
        fvcode:selectedData[0].fvcode,
        status:selectedData[0].status
      });
    } else if (selectedData.length > 1) {
      alert("Select Only one Record");
    } else {
      alert("Select atleast one Record");
    }
    
  }

  updatebcode(){
    if (this.fieldvisitForm.valid) {
      // for (let i = 0; i < this.fieldvisitForm.value.bank_id.length; i++) {
        const data = {
          bank_id: '',
          fvcode:this.fieldvisitForm.value.fvcode,
          status:this.fieldvisitForm.value.status
        }
        this._api.update_fieldvisit_code(data).subscribe(data=>{
          if (data['Code'] == 200) {
            alert(data['Message']);
            this.onreloadPage();
          } else {
            alert(data['Message']);
          }
        });
      // }
      
    } else {
      alert("Please Fill all fields");
    }
  }

  deletebcode(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data );
    if (selectedData.length >= 1) {
      for (let i = 0; i < selectedNodes.length; i++) {
        this._api.delete_fieldvisit_code(selectedData[i]._id).subscribe(data => {
          if (data['Code'] == 200) {
            this.onreloadPage();
          } else {
            
          }
        });
      }
      
    } else {
      alert("Select atleast one Record");
    }
  }

  cancel(){
    this.addmode = true;
    this.editmode = false;
    this.fieldvisitForm.reset();
  }

  onreloadPage(){
    this.cancel();
    this._api.getlist_fieldvisit_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.fieldvisitCodeList = data['Data'];
      } else {
        this.fieldvisitCodeList = [];
      }
    });
  }


}
